export type GradientPoint = {
  x: number;
  y: number;
};

/**
 * Mirror horizontal gradient vector in RTL so left→right scrims stay visually correct.
 */
export function resolveGradientVector(
  start: GradientPoint,
  end: GradientPoint,
  is_rtl: boolean,
  respect_rtl = true,
): { start: GradientPoint; end: GradientPoint } {
  if (!respect_rtl || !is_rtl) {
    return { start, end };
  }
  return {
    start: { x: 1 - start.x, y: start.y },
    end: { x: 1 - end.x, y: end.y },
  };
}

export function normalizeGradientLocations(
  color_count: number,
  locations?: readonly number[],
): number[] {
  if (color_count <= 0) {
    return [];
  }
  if (color_count === 1) {
    return [0];
  }
  if (locations != null && locations.length === color_count) {
    return locations.map(loc => Math.max(0, Math.min(1, loc)));
  }
  return Array.from({ length: color_count }, (_, index) => index / (color_count - 1));
}
